import React, { useRef } from "react";
import { Button } from "src/business-types/grocery/components/Button";
import { notifyError, notifySuccess, notifyWarning } from "../../../../../assets/toastService";
import { exportCategory, importCategory } from "../../../../../shared/services/services";
import iconMap from "src/assets/icons/Icons";

type Props = {
    showDeleted: boolean;
    onShowDeletedChange: (v: boolean) => void;
    onAdd: () => void;
    onRefresh: () => void;
    setLoading: (v: boolean) => void;
};

const CategoryActions: React.FC<Props> = ({ showDeleted, onShowDeletedChange, onAdd, onRefresh, setLoading }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const DownArrow = iconMap["down"];

    const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        if (![".xlsx", ".xls", ".csv"].some((ext) => file.name.endsWith(ext)))
            return notifyError("Please upload a valid Excel or CSV file.");
        try {
            setLoading(true);
            await importCategory(new FormData());
            onRefresh();
            notifySuccess("Category file imported successfully!");
        } catch { notifyError("Failed to import categories."); }
        finally { setLoading(false); }
    };

    const handleExport = async () => {
        try {
            setLoading(true);
            const res = await exportCategory();
            const blob = new Blob([res.data], { type: res.headers["content-type"] });
            const fileName = res.headers["content-disposition"]?.match(/filename="?(.+)"?/)?.[1] || "category_export.xlsx";
            const link = Object.assign(document.createElement("a"), { href: URL.createObjectURL(blob), download: fileName });
            document.body.appendChild(link); link.click(); link.remove();
            notifySuccess("Export successful!");
        } catch { notifyError("Export failed."); }
        finally { setLoading(false); }
    };

    return (
        <div className="w-full flex justify-end">
            <div className="w-fit grid grid-cols-3 gap-2 px-14 pt-2">
                <label className="flex items-center col-span-3 md:col-span-1 gap-2 cursor-pointer">
                    <input type="checkbox" className="w-5 h-5" checked={showDeleted} onChange={(e) => onShowDeletedChange(e.target.checked)} />
                    <span>View deleted</span>
                </label>
                <input type="file" accept=".xlsx,.xls,.csv" ref={fileInputRef} className="hidden" onChange={handleFileUpload} />
                <Button label="+ Category" onClick={onAdd} variant="ThemeBase" className="p-2 w-fit h-fit mt-4" />
                <Button variant="ThemeBase" onClick={() => notifyWarning("Coming soon")} icon={DownArrow} iconPosition="right" label="More Options" className="p-2 w-fit h-fit mt-4" />
            </div>
        </div>
    );
};

export default CategoryActions;